var map = {
	"./de-AT/messages.mjs": [
		652,
		5524
	],
	"./de-CH/messages.mjs": [
		45450,
		7066
	],
	"./de-DE/messages.mjs": [
		86626,
		8918
	],
	"./fr-BE/messages.mjs": [
		68189,
		1727
	],
	"./fr-CH/messages.mjs": [
		48283,
		2704
	],
	"./fr-FR/messages.mjs": [
		16160,
		5513
	],
	"./it-IT/messages.mjs": [
		50282,
		8322
	],
	"./nl-BE/messages.mjs": [
		71219,
		2715
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 69268;
module.exports = webpackAsyncContext;